import React, { Component } from "react";
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCalendarCheck,
    faDownload,
    faBan,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AdminLayout from '../UI/Layout/AdminLayout';
import Title from '../UI/Text/Title';
import { HOST_URL } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";
import Select from "react-select";

class AdminDownloadCentre extends Component {
    constructor() {
        const lStorage = JSON.parse(localStorage.getItem("admin"));
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        const adminType = lStorage?.user?.isAdmin;

        super();
        this.state = {
            downloadList: "",
            user_id: userId,
            token: userToken,
            type: adminType,
            channel: "",
            channelType: "",
            dateFrom: "",
            dateTo: "",
            SelecteddateFrom: "",
            SelecteddateTo: "",
            successShow: false,
            successMessage: "",
            errorMessage: "",
            bgColor: "",
            maxDate: null,
            allUsers: [],
            selecteduser: ""
        };
    }

    customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    // componentDidUpdate(prevProps, prevState) {
    //     if (
    //         this.state.user_id &&
    //         this.state.token &&
    //         (prevState.user_id !== this.state.user_id ||
    //             prevState.token !== this.state.token)
    //     ) {

    //     }
    // }

    componentDidMount() {
        this.fetchDownloadList();
        this.usersList();
    }

    fetchDownloadList = () => {
        Axios.post(`${HOST_URL}/download_centre.php`, {
            user_id: this.state.user_id,
            method: "retrieve_admin",
            token: this.state.token,
        })
            .then((response) => {
                const result = response.data;
                if (result.success === true) {
                    this.setState({ downloadList: result.data });
                }
            })
            .catch((error) => {
                console.error("Error fetching download list:", error);
            });
    };



    usersList = async () => {
        let paramData = {
            user_id: this.state.user_id,
            method: "retrieve_all_user",
            type: this.state.type,
            token: this.state.token,
        }
        try {
            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, paramData)

            if (data.success) {
                const formattedUsers = data.data.map((user) => ({
                    value: user.id,
                    label: user.email,
                    parent: user.parent,
                }));

                this.setState({ allUsers: formattedUsers })
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    handleUserChange = (selectedOption) => {
        this.setState({ selecteduser: selectedOption })
    }


    dataDownload() {
        if (this.state.selecteduser === "" || this.state.channel === "" || this.state.channelType === "" || this.state.dateFrom === "" || this.state.dateTo === "") {
            this.setState({
                successMessage: true,
                bgColor: "alert alert-danger alert-dismissible",
                errorMessage: "Please select all fields",
            });
            return;
        }

        let enddate;
        if (this.state.channelType === "campaign") {
            enddate = this.state.dateFrom;
        } else {
            enddate = this.state.dateTo;
        }
        // var date1 = new Date(this.state.dateFrom);
        // var date2 = new Date(this.state.dateTo);
        // var Difference_In_Time = date2.getTime() - date1.getTime();
        // var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        // //console.log('Difference_In_Days', Math.trunc(Difference_In_Days))

        // if (Math.trunc(Difference_In_Days) <= 15) {
        //   window.location.href = `${HOST_URL}/user_report.php?user_id=${this.state.user_id}&method=download&channel=sms&token=${this.state.token}&date_from=${this.state.dateFrom}&date_to=${this.state.dateTo}`;
        // } else {
        const downloadReportCenter = {
            user_id: this.state.user_id,
            channel: this.state.channel,
            token: this.state.token,
            method: "create_admin",
            startdate: this.state.dateFrom,
            ret_user_id: this?.state?.selecteduser?.value,
            enddate: this.state.dateTo,
            req_for: this.state.channelType,
        };

        fetch(`${HOST_URL}/download_centre.php`, {
            method: "post",
            headers: {
                "content-Type": "application/json",
            },
            body: JSON.stringify(downloadReportCenter),
        }).then((result) => {
            result.json().then((resp) => {
                //  console.log(resp);
                if (resp.success === true) {
                    document.querySelector("body").scrollTo(0, 0);
                    this.setState({
                        successMessage: true,
                        bgColor: "alert alert-success alert-dismissible",
                        errorMessage: resp.message,
                    });
                    setTimeout(function () {
                        window.location = "/admin/admin-download-center";
                    }, 1000);
                } else {
                    this.setState({
                        successMessage: true,
                        bgColor: "alert alert-danger alert-dismissible",
                        errorMessage: resp.message,
                    });
                }
            });
        });
        // }
    }

    dateFrom = (date) => {
        const fromDateFormatted =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            ("0" + date.getDate()).slice(-2);

        // Add 1 month to selected date
        const maxToDate = new Date(date);
        maxToDate.setMonth(maxToDate.getMonth() + 1);

        this.setState({
            dateFrom: fromDateFormatted,
            SelecteddateFrom: date,
            maxDate: maxToDate,   // 👈 Date To ke liye limit
            dateTo: "",
            SelecteddateTo: null,
        });
    };


    dateTo = (date) => {
        const toDateFormatted =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            ("0" + date.getDate()).slice(-2);

        this.setState({
            dateTo: toDateFormatted,
            SelecteddateTo: date,
        });
    };

    currentDate(currentDate) {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    addDays(date) {
        const days = 30;
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.SelecteddateFrom !== this.state.SelecteddateFrom) {
            let maxDatee = this.addDays(this.state.SelecteddateFrom)
            this.setState({
                maxDate: maxDatee
            })
        }
    }
    render() {
        console.log(this.state.selecteduser)
        const oneDayBefore = new Date();
        oneDayBefore.setDate(oneDayBefore.getDate() - 1);



        return (
            <AdminLayout>
                {/* <Title isButton={false}> Billing Report </Title> */}
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="row mb-2 mb-xl-3">
                            <div className="col-auto d-sm-block">
                                <h3>
                                    <strong>Download </strong> Centre{" "}
                                </h3>
                            </div>
                        </div>

                        <div className="card flex-fill support">
                            <div className="card-header">
                                {this.state.successMessage ? (
                                    <div className={this.state.bgColor} role="alert">
                                        <button
                                            type="button"
                                            className="close"
                                            data-dismiss="alert"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true">×</span>
                                        </button>
                                        <div className="">{this.state.errorMessage}</div>
                                    </div>
                                ) : null}

                                <div className="filter-option">
                                    <h6 className="card-subtitle text-muted">
                                        Select Date Range{" "}
                                    </h6>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="input-group mb-2 mr-sm-2">
                                                {/* <div className="input-group-text">
                            <FontAwesomeIcon icon={faBan} />
                          </div> */}
                                                <Select
                                                    onChange={this.handleUserChange}
                                                    options={this.state.allUsers}
                                                    value={this.state.selecteduser}
                                                    isSearchable={true}
                                                    placeholder="All Users"
                                                    isClearable={true}
                                                    styles={this.customStyles}
                                                // isDisabled={true}
                                                // isDisabled={this.state.updateId ? true : false}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="input-group mb-2 mr-sm-2">
                                                {/* <div className="input-group-text">
                            <FontAwesomeIcon icon={faBan} />
                          </div> */}
                                                <select
                                                    onChange={(event) =>
                                                        this.setState({ channel: event.target.value })
                                                    }
                                                    className="form-control"
                                                >
                                                    <option value=""> Select Channel </option>
                                                    <option value="sms"> sms </option>
                                                    <option value="email"> Email </option>
                                                    <option value="voice"> Voice </option>
                                                    <option value="whatsapp"> WhatsApp </option>
                                                    <option value="rcs"> RCS </option>
                                                </select>
                                            </div>
                                        </div>


                                        <div className="col-md-4">
                                            <div className="input-group mb-2 mr-sm-2">
                                                {/* <div className="input-group-text">
                            <FontAwesomeIcon icon={faBan} />
                          </div> */}
                                                <select
                                                    onChange={(event) =>
                                                        this.setState({
                                                            channelType: event.target.value,
                                                        })
                                                    }
                                                    className="form-control"
                                                >
                                                    <option value=""> Select Channel type</option>
                                                    <option value="api"> Api </option>
                                                    <option value="campaign"> Campaign </option>
                                                </select>
                                            </div>
                                        </div>


                                        <div className="col-md-4">
                                            <div className="input-group mb-2 mr-sm-2">
                                                {/* <div className="input-group-text">
                            <FontAwesomeIcon icon={faCalendarCheck} />
                          </div> */}

                                                {/* <DatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="yyyy/MM/dd"
                                                    value={this.state.dateFrom}
                                                    onChange={this.dateFrom}
                                                    maxDate={oneDayBefore}
                                                    selected={this.state.SelecteddateFrom}
                                                    selectsStart
                                                    startDate={this.state.SelecteddateFrom}
                                                    placeholderText="From Date"

                                                /> */}
                                                <DatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="yyyy/MM/dd"
                                                    selected={this.state.SelecteddateFrom}
                                                    onChange={this.dateFrom}
                                                    placeholderText="From Date"
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="input-group mb-2 mr-sm-2">
                                                {/* <div className="input-group-text">
                            <FontAwesomeIcon icon={faCalendarCheck} />
                          </div> */}

                                                {/* <DatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="yyyy/MM/dd"
                                                    value={this.state.dateTo}
                                                    onChange={this.dateTo}
                                                    // maxDate={oneDayBefore}
                                                    selected={this.state.SelecteddateFrom}
                                                    placeholderText="Date To"
                                                    selectsEnd
                                                    startDate={this.state.SelecteddateFrom}
                                                    minDate={this.state.SelecteddateFrom}
                                                    maxDate={this.state.maxDate}
                                                /> */}
                                                <DatePicker
                                                    className="form-control btn-block"
                                                    dateFormat="yyyy/MM/dd"
                                                    selected={this.state.SelecteddateTo}
                                                    onChange={this.dateTo}
                                                    placeholderText="Date To"
                                                    minDate={this.state.SelecteddateFrom}
                                                    maxDate={this.state.maxDate}   // 👈 max 1 month
                                                    selectsEnd
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <button
                                                type="button"
                                                onClick={() => this.dataDownload()}
                                                className="btn-success btn-sm btn-block ml-auto"
                                            >
                                                <FontAwesomeIcon icon={faDownload} /> Request Download
                                                Report{" "}
                                            </button>
                                        </div>

                                        <hr className="mt-2 mb-3" />
                                        <div className="col-md-7">
                                            <p className="mt-1">
                                                Download Center use for large data. Date range greater
                                                than 15 days. Download request will take upto 2
                                                minutes.{" "}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div
                                        style={{ height: 400 + "px", overflow: "auto" }}
                                        className=""
                                    >
                                        {this.state.downloadList ? (
                                            <table className="table table-hover my-0">
                                                <thead>
                                                    <tr>
                                                        <th>Username</th>
                                                        <th>Channel</th>
                                                        <th>Request Type</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Status</th>
                                                        <th>Request Date / Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.downloadList.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>
                                                                {this.state.allUsers.find(
                                                                    x => String(x.value) === String(item.user_id)
                                                                )?.label || ""}
                                                            </td>

                                                            <td>
                                                                {item.channel === "sms" ? (
                                                                    <span className="badge text-white badge-info">
                                                                        SMS
                                                                    </span>
                                                                ) : item.channel === "voice" ? (
                                                                    <span className="badge text-white bg-warning ">
                                                                        Voice
                                                                    </span>
                                                                ) : item.channel === "email" ? (
                                                                    <span className="badge text-white bg-danger">
                                                                        Email
                                                                    </span>
                                                                ) : item.channel === "whatsapp" ? (
                                                                    <span className="badge text-white badge-success">
                                                                        WhatsApp
                                                                    </span>
                                                                ) : item.channel === "rcs" ? (
                                                                    <span className="badge text-white bg-black">
                                                                        RCS
                                                                    </span>
                                                                ) : null}
                                                            </td>
                                                            <td>{item.req_for === "api" ? "API" : item.req_for}</td>
                                                            <td> {item.startdate}</td>
                                                            <td> {item.enddate}</td>
                                                            <td>
                                                                {item.status === 1 ? (
                                                                    <a
                                                                        target="_blank"
                                                                        href={
                                                                            item.linkfordownload
                                                                        }
                                                                    >
                                                                        <span className="badge text-white btn-primary">
                                                                            {" "}
                                                                            <FontAwesomeIcon
                                                                                icon={faDownload}
                                                                            />{" "}
                                                                            Download
                                                                        </span>
                                                                    </a>
                                                                ) : (
                                                                    <span>
                                                                        {" "}
                                                                        <span className="badge text-white bg-danger">
                                                                            Pending{" "}
                                                                        </span>{" "}
                                                                        <small className="ml-2">
                                                                            {" "}
                                                                            (Upto 2 minutes){" "}
                                                                        </small>
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td> {item.created_date}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="text-center">
                                                <div className="card-body">
                                                    <img
                                                        alt="Empty Data"
                                                        className="project-empty-img"
                                                        src={EmptyImg}
                                                    />
                                                    <p>No Download Request Yet</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </AdminLayout>
        );
    }
}

export default AdminDownloadCentre;
